import React, { useContext, useEffect } from "react";
import { DispatchContext, StateContext } from "../store/context";
import { UPDATE_ALERT } from "../store/types";
import { notification } from "antd";

const Alert: React.FC = (): null => {
  const { alert = null } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const { type = "info", message } = alert || {};

  useEffect(() => {
    if (alert && message) {
      notification[type as "success" | "error" | "info"]({
        message:
          type === "success" ? "Success" : type === "error" ? "Error" : "Info",
        description: message,
        placement: "topRight",
        duration: 5,
        onClose: () => dispatch({ type: UPDATE_ALERT, payload: null }),
      });

      const int = setInterval(() => {
        dispatch({ type: UPDATE_ALERT, payload: null });
        clearInterval(int);
      }, 5000);
    }
  }, [alert]);

  return null;
};

export default Alert;
